import { IoChevronDown, IoChevronUp } from "react-icons/io5";
import styles from "./NumberPicker.module.css";

export default function NumberPicker({ config, slotProps, inputProps }) {
	const disabled = inputProps.disabled || inputProps.readOnly;
	return (
		<div {...slotProps("numberPicker", styles.numberPickerControlsContainer)}>
			<button
				type="button"
				onClick={() => config.onIncrement?.()}
				disabled={disabled}
				aria-label="Increase value"
				{...slotProps("incrementButton", styles.numberPickerButton)}
			>
				<IoChevronUp size={16} aria-hidden="true" {...slotProps("incrementIcon", styles.numberPickerIcon)} />
			</button>
			<button
				type="button"
				onClick={() => config.onDecrement?.()}
				disabled={disabled}
				aria-label="Decrease value"
				{...slotProps("decrementButton", styles.numberPickerButton)}
			>
				<IoChevronDown size={16} aria-hidden="true" {...slotProps("decrementIcon", styles.numberPickerIcon)} />
			</button>
		</div>
	);
}
